﻿import { io, Socket } from "socket.io-client";
import { ACCESS_TOKEN_KEY } from "features/Authentication/store/login/reducer";

const SOCKET_URL =
  (import.meta.env.VITE_API_URL as string | undefined) ??
  "http://localhost:8000";

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io(SOCKET_URL, {
      autoConnect: false,
      auth: (cb: (data: { token: string }) => void) => {
        cb({ token: localStorage.getItem(ACCESS_TOKEN_KEY) ?? "" });
      },
    });
  }
  return socket;
}

export function connectSocket(): void {
  const s = getSocket();
  if (!s.connected) s.connect();
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}
